module.exports = __webpack_public_path__ + "img/kristina_pryanichnikova-min.849353b9.jpg";